import { AxiosResponse } from 'axios';
import client from '../../lib/service/publication.service';
import { CategoryImages } from './category-images.types';

type Response = {
  category_image: CategoryImages;
};

const CATEGORY_IMAGES = (categoryId: string) =>
  `/v1/categories/${categoryId}/category_images`;

export async function getCategoryImages(
  categoryId: string,
): Promise<CategoryImages> {
  const response = await client.get<null, AxiosResponse<Response>>(
    CATEGORY_IMAGES(categoryId),
  );
  return response.data.category_image;
}
